export default __webpack_public_path__ + "static/media/logo.24e44d29.svg";